'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'fish-bones';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e304';
var svgPathData = 'M32 96L0 128 64 256 0 384l32 32 64-64 0-48 0-24 40 0 0 72 0 24 48 0 0-24 0-72 48 0 0 72 0 24 48 0 0-24 0-72 48 0 0 72 0 24 48 0 0-24 0-72 40 0 0 72 0 11.8 0 7.8 0 28.4 32 0 16-18L576 256 464 130l-16-18-32 0 0 28.4 0 7.8 0 11.8 0 72-40 0 0-72 0-24-48 0 0 24 0 72-48 0 0-72 0-24-48 0 0 24 0 72-48 0 0-72 0-24-48 0 0 24 0 72-40 0 0-24 0-48L32 96zM464 202.2L511.8 256 464 309.8l0-107.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFishBones = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;